import React from 'react';
import PropTypes from 'prop-types';
import css from './StickyFooterLayout.css';
import classnames from 'classnames';
import { isEmptyString } from '../utils/text';

const StickyFooterLayout = React.forwardRef((props, ref) => (
  <div className={classnames(css['container'], {[props.className]: !isEmptyString(props.className)})}>
    {props.header}
    <div ref={ref} className={css['content']}>
      {props.content}
    </div>
    {props.footer}
  </div>
));

StickyFooterLayout.propTypes = {
  header: PropTypes.object,
  content: PropTypes.object.isRequired,
  footer: PropTypes.object,
  className: PropTypes.string
};

export default StickyFooterLayout;
